import ManageNewSale from "./manage-new-sale";
import ManageSale from "./manage-sale";
import Delete from "./delete";
import ViewSale from "./view-sale";

export const Sale = { ManageSale, Delete, ManageNewSale, ViewSale };
